import { BlockBlobClient } from "@azure/storage-blob";

export async function uploadFileToBlob(
    sasUrl: string,
    file: File,
    onProgress: (percent: number) => void,
    signal?: AbortSignal,
): Promise<void> {
    const client = new BlockBlobClient(sasUrl);
    await client.uploadData(file, {
        blockSize: 8 * 1024 * 1024,
        concurrency: 4,
        blobHTTPHeaders: { blobContentType: "image/tiff" },
        onProgress: (ev) => {
            onProgress(
                file.size > 0
                    ? Math.round((ev.loadedBytes / file.size) * 100)
                    : 0,
            );
        },
        abortSignal: signal,
    });
}
